var map = {
	"./banma.js": 1572,
	"./blackfish.js": 1573,
	"./default.js": 382,
	"./fenqile.js": 1574,
	"./guanaitong.js": 1575,
	"./hebeiyidong.js": 1576,
	"./nonghang.js": 1577,
	"./pufabank.js": 1578,
	"./yixiaoyuan.js": 1579,
	"./zhaohang.js": 1580
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2456;


//////////////////
// WEBPACK FOOTER
// ./src/mods/channels ^(.*\.(js$))[^.]*$/i
// module id = 2456
// module chunks = 153